import * as UTILS from "../utils/Utils";
export class Header {
  constructor() {
    this.header = document.querySelectorAll(".js-header");
    this.langButton = document.querySelectorAll(".js-language-button");
    this.hamburguerMenuButton = document.querySelectorAll(".js-button-menu");
    this.itemsHasSubmenu = document.querySelectorAll(".js-item-has-submenu");
    this.secondaryItemsHasSubmenu = document.querySelectorAll(
      ".js-secondary-item-has-submenu"
    );
    this.btnBackMenu = document.querySelectorAll(".js-back-menu-btn");
    this.submenuBox = document.querySelectorAll(".js-submenu-box");
    this.submenuTitle = document.querySelectorAll(".js-submenu-category");
    this.langBox = document.querySelectorAll(".js-language-box");
    this.hamburguerMenu = document.querySelectorAll(".js-main-nav-menu");

    this.hanldeLanguageButtonClick = this.hanldeLanguageButtonClick.bind(this);
    this.hanldeItemHasSubmenuClick = this.hanldeItemHasSubmenuClick.bind(this);
    this.hanldeSubmenuTitleClick = this.hanldeSubmenuTitleClick.bind(this);
    this.hanldeHamburguerButtonClick = this.hanldeHamburguerButtonClick.bind(
      this
    );

    this.init();
  }

  init() {
    this.initHandlers();
  }

  initHandlers() {
    this.langButton[0].addEventListener(
      "click",
      this.hanldeLanguageButtonClick
    );
    this.hamburguerMenuButton[0].addEventListener(
      "click",
      this.hanldeHamburguerButtonClick
    );
    this.itemsHasSubmenu.forEach(element => {
      element.addEventListener("click", event => {
        this.hanldeItemHasSubmenuClick(element, event);
      });
    });
    this.submenuTitle.forEach(element => {
      element.addEventListener("click", event => {
        this.hanldeSubmenuTitleClick(event, element);
      });
    });
    this.secondaryItemsHasSubmenu.forEach(element => {
      element.addEventListener("click", event => {
        this.hanldeSecondaryItemClick(event, element);
      });
    });
    this.btnBackMenu.forEach(element => {
      element.addEventListener("click", event => {
        this.handleBtnCloseClick(element);
      });
    });
  }

  hanldeLanguageButtonClick() {
    this.langBox[0].classList.toggle("ag-is-opened");
    return false;
  }

  hanldeHamburguerButtonClick() {
    this.hamburguerMenu[0].classList.toggle("ag-is-opened");
    this.header[0].classList.toggle("ag-is-active");
    return false;
  }

  hanldeItemHasSubmenuClick(element, event) {
    if (event.target === element || event.target.nodeName === "SPAN") {
      element.classList.toggle("ag-is-opened-megamenu");
    }
    return false;
  }

  hanldeSubmenuTitleClick(event, element) {
    event.stopPropagation();
    event.target.parentElement.classList.toggle("ag-is-opened-submenu");
    this.removeOpenSubmenuClass();
    const padreSubmenuBox = element.closest(".js-submenu-box");
    padreSubmenuBox.classList.add("is-show-submenu");
    return false;
  }

  handleBtnCloseClick(element) {
    const padreSubmenuBox = element.closest(".js-submenu-box");
    padreSubmenuBox.classList.remove("ag-is-opened-submenu");
  }

  hanldeSecondaryItemClick(event, element) {
    if (event.target === element || event.target.nodeName === "SPAN") {
      element.classList.toggle("is-active");
      element.classList.toggle("is-menu-opened");
      return false;
    }
  }

  removeOpenSubmenuClass() {
    this.submenuBox.forEach(element => {
      element.classList.remove("is-show-submenu");
    });
  }
}
